import { CountUp } from 'countup.js';

export function initCounter(counterElements) {
    const _countUp = Symbol();

    let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target[_countUp].start();
            }
        });
    });

    counterElements.forEach((elCounter) => {
        let dataset = elCounter.dataset,
            { endVal = '100' } = dataset,
            options = {
                useEasing: true,
                useGrouping: true,
                separator: '.',
                decimal: ',',
                ...dataset,
            },
            countUp;

        // sanitize input
        if (options.startVal && isNaN(Number(options.startVal))) {
            options.startVal = options.startVal.replace('.', '').replace(',', '.');
        }

        if (isNaN(Number(endVal))) {
            endVal = endVal.replace('.', '').replace(',', '.');
        }

        countUp = new CountUp(elCounter, endVal, options);
        elCounter[_countUp] = countUp;
        observer.observe(elCounter);
    });
}
